import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'components';
import { P } from 'components/Typography/Typography';
import { dateHoursFormat } from 'constants/dateFormats/dateHourFormat';
import { format } from 'date-fns';
import styled from 'styled-components';
import { IExecutionProgressTracking } from 'types/executionProgressTrackings';
import {
  IExecutionProgressStatus,
  IExecutionProgressStatusAttribute
} from 'types/executionProgressStatuses';
import { IUser } from 'types/user';
import { findLastExecutionProgressTrackingLetter } from 'utilities/lastExecutionProgressTrackingLetter';

const Wrapper = styled(Flex)`
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.neutral.lightGrey};
  flex-direction: column;
  padding: 6px;
`;

const StyledImg = styled.img`
  object-fit: cover;
`;

const StyledButton = styled.button`
  background: transparent;
`;

interface Props {
  executionProgressTracking: IExecutionProgressTracking;
  executionProgressStatuses?: (
    | IExecutionProgressStatusAttribute
    | IExecutionProgressStatus
  )[];
  usersList?: IUser[];
  handleRemoveExecutionProgressStatus?: (kind: string) => void;
}

export const ExecutionProgressStatusInfo: React.FC<Props> = ({
  executionProgressTracking,
  executionProgressStatuses,
  usersList,
  handleRemoveExecutionProgressStatus
}) => {
  const letters = executionProgressTracking.kind.split('');

  const lastExecutionProgressTrackingLetter = findLastExecutionProgressTrackingLetter(
    executionProgressTracking,
    executionProgressStatuses || []
  );

  return (
    <Wrapper>
      {letters.map((letter) => {
        const executionProgressStatus = executionProgressStatuses?.find(
          ({ kind }) => kind === letter
        );

        const user = usersList?.find(
          ({ id }) => id === executionProgressStatus?.approver_id
        );

        return (
          <Flex
            minWidth="160px"
            key={`ExecutionProgressStatusInfo-${letter}`}
            gap="4px"
          >
            <P variant="body" color="green">
              {letter}:
              {executionProgressStatus?.confirmed_at &&
                format(
                  new Date(executionProgressStatus.confirmed_at),
                  dateHoursFormat
                )}
            </P>
            {executionProgressStatus && user && (
              <>
                <StyledImg
                  width="20px"
                  height="20px"
                  src={`${process.env.REACT_APP_API_URL}${user.profile?.photo}`}
                  alt={user.email}
                />
                {executionProgressStatus.kind ===
                  lastExecutionProgressTrackingLetter && (
                  <StyledButton>
                    <FontAwesomeIcon
                      color="grey"
                      icon={faRotateLeft}
                      onClick={() => {
                        handleRemoveExecutionProgressStatus?.(letter);
                      }}
                    />
                  </StyledButton>
                )}
              </>
            )}
          </Flex>
        );
      })}
    </Wrapper>
  );
};
